import React, { useRef, useState } from "react";
import Link from "@mui/material/Link";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import useOpenSignedPdfUrl from "src/hooks/useOpenSignedPdfUrl";

const LONG_PRESS_DELAY_MS = 650;

export default function PdfGenerateLink({
  resourceType,
  resourceId,
  label = "Generate",
  regenerateLabel = "Force Regenerate PDF",
  extraQueryParams = {},
  sx,
  color,
  variant,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const longPressTimerRef = useRef(null);
  const suppressClickRef = useRef(false);
  const open = Boolean(anchorEl);

  const openPdfReport = useOpenSignedPdfUrl({
    resourceType,
    resourceId,
    extraQueryParams,
  });
  const openRegeneratedPdf = useOpenSignedPdfUrl({
    resourceType,
    resourceId,
    extraQueryParams: { ...extraQueryParams, force_pdf_regeneration: true },
  });

  const clearLongPressTimer = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  };

  const startLongPress = (event) => {
    event.stopPropagation();
    const target = event.currentTarget;
    clearLongPressTimer();
    longPressTimerRef.current = setTimeout(() => {
      suppressClickRef.current = true;
      setAnchorEl(target);
    }, LONG_PRESS_DELAY_MS);
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (suppressClickRef.current) {
      suppressClickRef.current = false;
      return;
    }

    openPdfReport(event);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRegenerate = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleMenuClose();
    openRegeneratedPdf(event);
  };

  return (
    <>
      <Link
        href="#"
        color={color}
        variant={variant}
        sx={sx}
        onClick={handleClick}
        onMouseDown={startLongPress}
        onMouseUp={clearLongPressTimer}
        onMouseLeave={clearLongPressTimer}
        onTouchStart={startLongPress}
        onTouchEnd={clearLongPressTimer}
      >
        {label}
      </Link>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem onClick={handleRegenerate}>{regenerateLabel}</MenuItem>
      </Menu>
    </>
  );
}
